import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type {
  AcquirerTerminalGridRow,
  MappingGridRow,
  MerchantTerminalGridRow,
} from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const TERMINALS_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filter: {
    component: 'agTextColumnFilter',
    doesFilterPass: () => true,
  },
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const mappingGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No terminals match the current filters.</span>',
} satisfies GridOptions<MappingGridRow>;

export const merchantTerminalGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No merchant terminals match the current filters.</span>',
} satisfies GridOptions<MerchantTerminalGridRow>;

export const acquirerTerminalGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No acquirer terminals match the current filters.</span>',
} satisfies GridOptions<AcquirerTerminalGridRow>;
